import React from "react";
import { ActionButton, Icon } from "@culturehq/components";

import { t, Trans } from "app/utils";
import surveyItemTypes from "constants/surveyItemTypes";

import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";
import SurveyItemEditModal from "./SurveyItemEditModal";

const SurveyItemListRow = ({
  survey,
  event,
  surveyItem,
  onSurveyItemUpdated,
  onSurveyItemDeleted
}) => {
  const itemType = surveyItemTypes.find(({ value }) => value === surveyItem.itemType);
  const isLocked = surveyItem.prompt === "How would you rate this event?";
  const className = !isLocked ? "sortable__drag-handler" : null;

  return (
    <tr data-id={surveyItem.id} className="SurveyItems__row">
      <td className={className} />
      <td>
        <Icon icon={itemType.icon} />
      </td>
      <td>{surveyItem.prompt}</td>
      <td>
        {itemType.name} -{" "}
        <span className="light small">{itemType.description}</span>
      </td>
      <td>
        {isLocked && <ActionButton icon="android-lock" aria-label="Locked" />}

        {!isLocked && surveyItem.id && (
          <ChqModalConfirmDelete
            onAccept={() => onSurveyItemDeleted(surveyItem)}
            trigger={onTrigger => (
              <ActionButton icon="trash-a" onClick={onTrigger} aria-label={`${t("Delete")} ${surveyItem.prompt}, ${itemType.name} - ${itemType.description}`} />
            )}
          >
            <Trans>
              Are you sure you would like to delete this survey question? Any
              submitted answers to this question will be lost.
            </Trans>
          </ChqModalConfirmDelete>
        )}

        {!isLocked && surveyItem.id && (
          <SurveyItemEditModal
            survey={survey}
            event={event}
            surveyItem={surveyItem}
            onCallback={onSurveyItemUpdated}
            isEdit
          >
            {onTrigger => (
              <ActionButton icon="edit" onClick={onTrigger} aria-label={`${t("Edit")} ${surveyItem.prompt}, ${itemType.name} - ${itemType.description}`} />
            )}
          </SurveyItemEditModal>
        )}
      </td>
    </tr>
  );
};

export default SurveyItemListRow;
